import styled, { keyframes } from 'styled-components'
import colors from 'configuration/colors'

// styles
const DotFlashingAnime = keyframes`
    0% { background-color: ${colors.aluminum} }
    50%{ background-color: ${colors.silver} }
    100% { background-color: ${colors.rock} }
`

const DotFlashing = styled.div`
  margin-left: 20px;
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: ${colors.aluminum};
  color: ${colors.aluminum};
  animation: ${DotFlashingAnime} 1s infinite linear alternate;
  animation-delay: 0.25s;
  &:before,
  &:after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }
  &:before {
    left: -10px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: ${colors.silver};
    color: ${colors.silver};
    animation: ${DotFlashingAnime} 1s infinite alternate;
    animation-delay: 0s;
  }
  &:after {
    left: 10px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: ${colors.rock};
    color: ${colors.rock};
    animation: ${DotFlashingAnime} 1s infinite alternate;
    animation-delay: 0.5s;
  }
`
DotFlashing.displayName = 'DotFlashing'

export { DotFlashing }
